<div id="requestAccessModal" class="modal fade rating-modal" role="dialog">
    <div class="modal-dialog modal-md rating-modal-dialog">
      <div class="modal-header row">
        <h5 class="col-md-11 modal-heading">Select items for which access is required</h5>
        <button type="button" class="close col-md-1" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-content">
        <div class="modal-body">
          <div class="filter-checkbox">
            <input type="checkbox" class="form-check-input" [ngModel]="supportingMaterials" (click)="setFlags('Supporting Material')"/>
            <label>Supporting Materials</label>
          </div>
          <div class="filter-checkbox" *ngIf="accessCodePresent">
            <input type="checkbox" class="form-check-input" [ngModel]="accessCode" (click)="setFlags('Access code')"/>
            <label>Code Repo</label>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button type="button"
        class="btn btn-primary submit-btn" (click)="openMailForAccessRequest()" data-dismiss="modal" [disabled]="isDisabled">Done</button>
        </div>
      </div>
  
    </div>
  </div>
